$(document).ready(function () {
    $('.editaccess-btn').on('click', function () {
        var id         = $(this).data('id');
        var block      = $(this).data('block');
        var expirydate = $(this).data('expirydate');
        var student    = $(this).data('student');

        $('span.block').empty().append(student + ' Block ' + block);
        $('input[type="hidden"][name="id"]').val(id);
        $('input[type="text"][name="expirydate"]').val(dayjs.unix(expirydate).format('YYYY/MM/DD H:m'));
    });

    $('.addaccess-btn').on('click', function () {
        var acyr = $(this).data('acyr');
        $('input[type="hidden"][name="acyr"]').val(acyr);
        $('input[type="hidden"][name="expirydate"]').val(dayjs().add(2, 'week').unix());
    });

    $('#expirydate').datetimepicker({
        format: 'Y/m/d H:i',
        minDate: 0,
    });
});
